export default __webpack_public_path__ + "static/media/login_mv_bg.9b8e89da.jpg";